"use client";

import {Library, Sparkles, UserRound} from 'lucide-react';
import {openBiteLogin} from '@/lib/bite-signup-referral';
import {BiteButton} from './bite-ui';
import './bite-app-shell.css';

const destinations = {
  '/bite/collection': {title:'내 보관함', Icon:Library, description:'로그인하고 내 보고서와 소장한 캐릭터 카드를 확인하세요.'},
  '/bite/pro': {title:'Pro 구독하기', Icon:Sparkles, description:'로그인하고 나에게 맞는 이용 플랜을 확인하세요.'},
  '/bite/me': {title:'내 계정', Icon:UserRound, description:'로그인하고 내 계정과 이용 중인 플랜을 확인하세요.'},
};

export function BiteLoginRequired({pathname}:{pathname:string}) {
  const {title,Icon,description}=destinations[pathname as keyof typeof destinations]||destinations['/bite/me'];
  return <main className="bite-login-required">
    <h1>{title}</h1>
    <section className="bite-login-required__body" aria-labelledby="bite-login-required-title">
      <span className="bite-login-required__icon"><Icon aria-hidden="true"/></span>
      <h2 id="bite-login-required-title">로그인 후 이용 가능합니다.</h2>
      <p>{description}</p>
      <BiteButton data-track="bite.login_required.open" size="lg" onClick={()=>{void openBiteLogin(window.location.pathname+window.location.search+window.location.hash);}}>로그인하기</BiteButton>
    </section>
  </main>;
}
